import '../../WithCallout.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsxs, jsx } from "react/jsx-runtime";
import { Callout } from "@fluentui/react/lib/Callout";
import * as React from "react";
import "../../Utilities.js";
import "../../FocusZone.js";
import "../../Styling.js";
import "../ContextualMenu.js";
import { KeyCodes, css } from "@fluentui/utilities";
import { DirectionalHint } from "@fluentui/react/lib/ContextualMenu";
import { concatStyleSets } from "@fluentui/style-utilities";
import { FocusZone, FocusZoneDirection } from "@fluentui/react-focus";
const WithCallout$1 = "";
const defaultClassName = "ane-WithCallout";
class WithCallout extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "_menuButtonElement", React.createRef());
    __publicField(this, "_closeTimer");
    // use _ignoreNextFocusEvent to prevent showing the Callout again when it is dismissed
    // by the user (either through tabbing through the content, hitting esc, or mousing out)
    __publicField(this, "_ignoreNextFocusEvent", false);
    // ignore if last was NOT from mouseenter
    __publicField(this, "_lastShowCalloutFromMouseEnter", false);
    __publicField(this, "state", {
      isCalloutVisible: false
    });
    __publicField(this, "_clearTimer", () => {
      !!this._closeTimer && clearTimeout(this._closeTimer);
    });
    __publicField(this, "_onBlur", () => {
      this._ignoreNextFocusEvent = false;
    });
    __publicField(this, "_onShowCallout", (fromMouseEnter) => {
      this._lastShowCalloutFromMouseEnter = fromMouseEnter;
      if (this._ignoreNextFocusEvent) {
        this._ignoreNextFocusEvent = false;
        return;
      }
      this._clearTimer();
      this.setState({ isCalloutVisible: true });
    });
    __publicField(this, "_onKeyDown", (event, closeOnTab) => {
      const { isCalloutVisible } = this.state;
      if (!event.defaultPrevented && (event.which === KeyCodes.escape || closeOnTab && event.which === KeyCodes.tab)) {
        this._clearTimer();
        this.setState({ isCalloutVisible: !isCalloutVisible });
      }
    });
    __publicField(this, "_onMouseEnter", () => {
      const { showOnHover } = this.props;
      if (!!showOnHover) {
        this._ignoreNextFocusEvent = false;
        this._onShowCallout(
          /*fromMouse=*/
          true
        );
      }
    });
    __publicField(this, "_onMouseLeave", () => {
      const { showOnHover } = this.props;
      this._ignoreNextFocusEvent = false;
      if (!!showOnHover) {
        this._clearTimer();
        this._closeTimer = setTimeout(() => {
          this.setState({ isCalloutVisible: false });
        }, this.props.autoHideDelay);
      }
    });
    __publicField(this, "_onDismissCallout", (ev) => {
      const { calloutProps } = this.props;
      const { onDismiss } = calloutProps || {};
      !!onDismiss && onDismiss(ev);
      if (!!ev && !ev.defaultPrevented) {
        this._clearTimer();
        this.setState({ isCalloutVisible: false });
      }
    });
  }
  render() {
    var _a;
    return ((_a = this.props.calloutProps) == null ? void 0 : _a.content) ? this.renderWithCallout() : this.props.children;
  }
  renderWithCallout() {
    var _c;
    const _a = this.props, {
      calloutProps,
      className,
      ariaLabel,
      autoHideDelay: delay,
      showOnHover,
      id,
      preventAutoTabIndex
    } = _a, rest = __objRest(_a, [
      "calloutProps",
      "className",
      "ariaLabel",
      "autoHideDelay",
      "showOnHover",
      "id",
      "preventAutoTabIndex"
    ]);
    const _b = calloutProps || {}, { heading, content, directionalHint = DirectionalHint.topCenter } = _b, restCalloutProps = __objRest(_b, ["heading", "content", "directionalHint"]);
    const tabIndex = preventAutoTabIndex ? void 0 : 0;
    return /* @__PURE__ */ jsxs(
      "div",
      __spreadProps(__spreadValues({
        className: css(defaultClassName, className),
        onMouseEnter: this._onMouseEnter,
        onMouseLeave: this._onMouseLeave,
        onKeyDown: (e) => this._onKeyDown(e, false)
      }, rest), {
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              ref: this._menuButtonElement,
              style: { display: "inline-block" },
              onFocus: () => this._onShowCallout(
                /*fromMouse=*/
                false
              ),
              onBlur: this._onBlur,
              tabIndex,
              children: this.props.children
            }
          ),
          this.state.isCalloutVisible && /* @__PURE__ */ jsx(
            Callout,
            __spreadProps(__spreadValues({
              role: "alert",
              styles: concatStyleSets(
                {
                  root: {
                    maxWidth: "500px"
                  }
                },
                (_c = this.props.calloutProps) == null ? void 0 : _c.styles
              )
            }, restCalloutProps), {
              onRestoreFocus: (params) => {
                this._ignoreNextFocusEvent = !!this._lastShowCalloutFromMouseEnter ? false : (document == null ? void 0 : document.activeElement) === params.originalElement;
                this._lastShowCalloutFromMouseEnter = false;
                params.originalElement.focus();
              },
              doNotLayer: false,
              setInitialFocus: true,
              className: css("ane-WithCallout-callout", className),
              gapSpace: 0,
              target: this._menuButtonElement.current,
              onDismiss: this._onDismissCallout,
              directionalHint,
              children: /* @__PURE__ */ jsx(FocusZone, { direction: FocusZoneDirection.bidirectional, children: /* @__PURE__ */ jsxs("div", { onMouseEnter: this._clearTimer, onMouseLeave: this._onMouseLeave, onKeyDown: (e) => this._onKeyDown(e, true), children: [
                !!heading && /* @__PURE__ */ jsx("div", { className: css("ane-WithCallout-header", className), children: /* @__PURE__ */ jsx("h3", { className: css("ane-WithCallout-title", className), children: heading }) }),
                /* @__PURE__ */ jsx("div", { className: css("ane-WithCallout-inner", className), children: /* @__PURE__ */ jsx("div", { className: css("ane-WithCallout-content", className), children: /* @__PURE__ */ jsx("div", { className: css("ane-WithCallout-subText", className), children: content }) }) })
              ] }) })
            })
          )
        ]
      })
    );
  }
}
__publicField(WithCallout, "defaultProps", {
  ariaLabel: "",
  calloutProps: { heading: "", content: "" },
  autoHideDelay: 100,
  showOnHover: true
});
export {
  WithCallout,
  WithCallout as default
};
//# sourceMappingURL=WithCallout.js.map
